<div class="PGCalendar {{isLoading ? 'PGCalendar--IsLoading' : ''}}">
    <div class="PGCalendar-Header">
        <div class="PGCalendar-Header-Controls bg-light">
            <div class="PGCalendar-Header-Controls-Left">
                <button class="btn btn-primary {{smallMode ? 'btn-sm' : ''}}" [tabIndex]="smallMode ? -1 : 0" (click)="year = year - 1"><i class="fa-regular fa-angle-double-left"></i></button>
                <button class="btn btn-primary {{smallMode ? 'btn-sm' : ''}}" [tabIndex]="smallMode ? -1 : 0" (click)="month = month - 1"><i class="fa-regular fa-angle-left"></i></button>
            </div>
            <div class="PGCalendar-Header-Controls-Center">
                @if (!smallMode) {
                    <select [(ngModel)]="month" class="form-control {{smallMode ? 'form-control-sm' : ''}}">
                        @for (monthIndex of [0,1,2,3,4,5,6,7,8,9,10,11]; track monthIndex) {
                            <option value="{{monthIndex}}">{{localizationService.data.monthNames[monthIndex]}}</option>
                        }
                    </select>
                }
                @if (!smallMode) {
                    <select [(ngModel)]="year" class="form-control {{smallMode ? 'form-control-sm' : ''}}">
                        @for (yearOffset of [-5,-4,-3,-2,-1,0,1,2,3,4,5]; track yearOffset) {
                            <option value="{{year + yearOffset}}">{{year + yearOffset}}</option>
                        }
                    </select>
                }
                @if (smallMode) {
                    <span>{{localizationService.data.monthNames[month]}} {{year}}</span>
                }
            </div>
            <div class="PGCalendar-Header-Controls-Right">
                <button class="btn btn-primary {{smallMode ? 'btn-sm' : ''}}" [tabIndex]="smallMode ? -1 : 0" (click)="month = month + 1"><i class="fa-regular fa-angle-right"></i></button>
                <button class="btn btn-primary {{smallMode ? 'btn-sm' : ''}}" [tabIndex]="smallMode ? -1 : 0" (click)="year = year + 1"><i class="fa-regular fa-angle-double-right"></i></button>
            </div>
        </div>
        <div class="PGCalendar-Header-Days bg-light">
            @for (day of [0,1,2,3,4,5,6]; track day) {
                <div>
                    {{localizationService.data.dayNames[(day + localizationService.data.weekStart) % 7].substring(0, 3)}}
                </div>
            }
        </div>
    </div>
    @if (weeks != null) {
        <div class="PGCalendar-Content">
            @if (isLoading && !smallMode) {
                <div class="PGCalendar-Loading">
                    <app-pg-loading></app-pg-loading>
                </div>
            }
            @for (week of weeks; track week) {
                <div class="PGCalendar-Content-Week">
                    @for (day of week; track day) {
                        <div class="PGCalendar-Content-Week-Day {{getFlagClasses(day)}} border" (click)="setSelectedDay(day)">
                            @if (day != null) {
                                <div>
                                    <span class="PGCalendar-Content-Week-Day-Title">
                                        {{day.date.day}}
                                    </span>
                                    <div class="PGCalendar-Content-Week-Day-Events text-muted">
                                        @for (element of day.elements; track element; let i = $index) {
                                            <span>
                                                @if (i < maxEventsDisplay) {
                                                    <div class="PGCalendar-Content-Week-Day-Events-Element">
                                                        <span>{{localizationService.format.time(element.start)}}@if (element.end != null) {
                                                            - {{localizationService.format.time(element.end)}}
                                                        }</span>
                                                        @if (element.status != null) {
                                                            <span class="badge bg-{{getEventStatusColor(element) || 'secondary'}} text-white PGCalendar-Content-Week-Day-Events-Element-Status" title="{{getEventStatusTitle(element)}}">
                                                                <i class="fa-regular {{getEventStatusIcon(element) || 'fa-clock' }}"></i>
                                                            </span>
                                                        }
                                                        @if (element.value != null) {
                                                            <span class="badge text-white PGCalendar-Content-Week-Day-Events-Element-Value" [ngClass]="{ 'bg-secondary': element.value == 0, 'bg-success': element.value &gt; 0, 'bg-danger': element.value &lt; 0 }">
                                                                {{element.value}}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                            </span>
                                        }
                                        @if (day.elements.length > maxEventsDisplay) {
                                            <div class="PGCalendar-Content-Week-Day-Events-More">+{{day.elements.length - maxEventsDisplay}}</div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
    @if (selectedDay != null && selectedDay.elements != null && selectedDay.elements.length > 0) {
        <div class="PGCalendar-Detail border" appPgAnimations="Grow;origin:{{getDetailAnimationOrigin()}}">
            <div class="PGCalendar-Detail-Header bg-light">
                <span>{{localizationService.data.dayNames[selectedDay.date.weekday]}} {{selectedDay.date.day}} {{localizationService.data.monthNames[selectedDay.date.month]}} {{selectedDay.date.year}}</span>
                <button class="btn btn-primary" (click)="selectedDay = null"><i class="fa-regular fa-times"></i></button>
            </div>
            <div class="PGCalendar-Detail-Content border-top border-bottom">
                @for (element of selectedDay.elements; track element) {
                    <div class="PGCalendar-Detail-Content-Element border-bottom" appPgAnimations="FadeIn">
                        <div class="PGCalendar-Detail-Content-Element-Header text-muted">
                            @if (element.status != null) {
                                <span class="badge bg-{{getEventStatusColor(element)}} text-white">{{getEventStatusTitle(element)}}</span>
                            }
                            <div class="PGCalendar-Detail-Content-Element-Header-Timespan">
                                <i class="fa-regular fa-clock"></i>
                                @if (element.end != null) {
                                    <span>
                                        Dalle <b>{{localizationService.format.time(element.start)}}</b> alle <b>{{localizationService.format.time(element.end)}}</b>
                                    </span>
                                }
                                @if (element.end == null) {
                                    <span>
                                        Alle <b>{{localizationService.format.time(element.start)}}</b>
                                    </span>
                                }
                            </div>
                        </div>
                        <div class="PGCalendar-Detail-Content-Element-Title">{{element.title}}</div>
                        <div class="PGCalendar-Detail-Content-Element-Content text-muted">{{element.description}}</div>
                        @if (getAvailableActions(); as actions) {
                            <div class="PGCalendar-Detail-Content-Element-Actions">
                                @if (actions.book) {
                                    <button class="btn btn-primary" (click)="onElementAction('book', element)">
                                        Prenota
                                    </button>
                                }
                                @if (actions.edit) {
                                    <button class="btn btn-primary" (click)="onElementAction('edit', element)">
                                        @if (actions.edit) {
                                            <i class="fa-regular fa-edit"></i>
                                        }
                                    </button>
                                }
                                @if (!actions.edit && actions.view) {
                                    <button class="btn btn-primary" (click)="onElementAction('view', element)">
                                        <i class="fa-regular fa-chevron-right"></i>
                                    </button>
                                }
                                @if (actions.delete) {
                                    <button class="btn btn-danger" (click)="onElementAction('delete', element)">
                                        <i class="fa-regular fa-trash"></i>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="PGCalendar-Detail-Footer bg-light">
                <span class="PGCalendar-Detail-Footer-Title">Date a {{localizationService.data.monthNames[selectedDay.date.month]}} {{selectedDay.date.year}}:</span>
                <ul class="pagination">
                    @if (daysWithElementsAround[0] != daysWithElements[0]) {
                        <li class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
                    }
                    @for (day of daysWithElementsAround; track day) {
                        <li class="page-item {{selectedDay == day ? 'active' : ''}}" (click)="setSelectedDay(day)">
                            <a class="page-link" href="javascript:void(0)">{{day.date.day}}</a>
                        </li>
                    }
                    @if (daysWithElementsAround[daysWithElementsAround.length - 1] != daysWithElements[daysWithElements.length - 1]) {
                        <li class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</div>
